import React from 'react'

export const HotelsIcon = ({size = 20}: {size?: number}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M20.3337 9.29333C20.3337 8.8331 20.7068 8.46 21.1671 8.46C21.6273 8.46 22.0004 8.8331 22.0004 9.29333V17.21C22.0004 17.6702 21.6273 18.0433 21.1671 18.0433C20.7068 18.0433 20.3337 17.6702 20.3337 17.21V16.3767C20.3337 16.1465 20.1472 15.96 19.9171 15.96H4.08372C3.85361 15.96 3.66706 16.1465 3.66706 16.3767V17.21C3.66706 17.6702 3.29396 18.0433 2.83372 18.0433C2.37349 18.0433 2.00039 17.6702 2.00039 17.21V6.79333C2.00039 6.3331 2.37349 5.96 2.83372 5.96C3.29396 5.96 3.66706 6.3331 3.66706 6.79333V13.8767C3.66706 14.1068 3.85361 14.2933 4.08372 14.2933H19.9171C20.1472 14.2933 20.3337 14.1068 20.3337 13.8767V9.29333Z"
      fill="currentColor"
    />
    <path
      d="M9.50039 13.2517H18.3896C18.6628 13.2517 18.9107 13.0914 19.0227 12.8421C19.1348 12.5928 19.0901 12.301 18.9087 12.0967C17.1946 10.1683 13.7504 8.97833 9.75789 9.09333C9.38267 9.10415 9.08402 9.41129 9.08372 9.78667V12.835C9.08372 13.0651 9.27027 13.2517 9.50039 13.2517Z"
      fill="currentColor"
    />
    <path
      d="M6.16706 13.2517C7.08753 13.2517 7.83372 12.5055 7.83372 11.585C7.83372 10.6645 7.08753 9.91833 6.16706 9.91833C5.24658 9.91833 4.50039 10.6645 4.50039 11.585C4.50039 12.5055 5.24658 13.2517 6.16706 13.2517Z"
      fill="currentColor"
    />
  </svg>
)
